import React from 'react';
import {FormattedMessage, useIntl} from 'react-intl';
import {NavLink} from 'react-router-dom';
import {Button, Space} from 'antd';

import {Select} from 'components/Form';
import {useT} from 'hooks/Locale/useT';

import {PositionOptions} from '../InstructionsTab/useVideoInstructions';
import {SupportTabKey} from '../types';

interface SupportToolbarProps {
    activeKey: SupportTabKey;
    canEdit: boolean;
    userRole: string;
    positions?: PositionOptions;
    positionsLoading: boolean;
    onPositionChange: (position: number) => void;
    onCreateClick: () => void;
}

// tabBarExtraContent lives on the Tabs bar itself (not inside a tab panel),
// so which controls show depends on the currently active tab key.
const SupportToolbar: React.FC<SupportToolbarProps> = ({
    activeKey,
    canEdit,
    userRole,
    positions,
    positionsLoading,
    onPositionChange,
    onCreateClick,
}) => {
    const intl = useIntl();
    const t = useT();

    return (
        <Space>
            {activeKey === 'instructions' && canEdit && (
                <>
                    <Select
                        className='instruction-filter-select'
                        allowClear
                        customLayout={{labelCol: {span: 0}, wrapperCol: {span: 24}}}
                        name='position'
                        integerKey={true}
                        placeholder={intl.formatMessage({id: 'system.video.all_instructions'})}
                        validation={{required: true}}
                        manualOptions={positions}
                        loading={positionsLoading}
                        onChange={(el: number) => onPositionChange(el)}
                    />
                    <span style={{width: 10}}/>
                    {userRole !== 'CUSTOMER_ADMIN' && userRole !== 'STUDENT' && (
                        <Button style={{marginRight: 18}} type='primary' onClick={onCreateClick}>
                            <i className='far fa-plus'></i> <FormattedMessage id='system.add_video'/>
                        </Button>
                    )}
                </>
            )}
            {activeKey === 'terms-and-conditions' && canEdit && (
                <div className='terms-conditions-button'>
                    <NavLink to='/terms-and-conditions/edit'>
                        <Button type='primary' className='terms-edit-button'>
                            {t('general.edit')}
                        </Button>
                    </NavLink>
                </div>
            )}
        </Space>
    );
};

export default SupportToolbar;
